/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Agent_Instructions_Chip2_AnswerInputs */



/**
* | output |
* | --- |
* | "Yes. Open the agent in the agent list and edit the instructions at any time; the next run uses the new version." |
*
* @param {Uno_Edu_Agent_Instructions_Chip2_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_agent_instructions_chip2_answer = /** @type {((inputs?: Uno_Edu_Agent_Instructions_Chip2_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Agent_Instructions_Chip2_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ja. Öffnen Sie den Agenten in der Agentenliste und ändern Sie die Beschreibung jederzeit; der nächste Lauf nutzt die neue Fassung.")
	return /** @type {LocalizedString} */ ("Yes. Open the agent in the agent list and edit the instructions at any time; the next run uses the new version.")
});